// Copyright (c) 2020 Deere & Company

import additionalDataFlag from './additional-data-flag';
import additionalDataInfo from './additional-data-info';
import additionalDataTestDomain from './additional-data-test-domain';
import additionalDataTypeDomain from './additional-data-type-domain';
import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import file from './file';
import isEmptyRgaSearchResult from './rga-search-result-flag';
import resultsNavigation from './results-navigation';
import rgaConsignmentDetails from './rga-consignment-details';
import rgaDealerDetails from './rga-dealer-details';
import rgaDetails from './rga-details';
import rgaQuestionAnswer from './rga-question-answer';
import rgaResultList from './rga-search-result';
import rgaSelectedMassUpdate from './rga-selected-mass-update';
import searchFilters from './search-filters';

export const getCombinedReducers = () => combineReducers({
    additionalDataFlag,
    additionalDataInfo,
    additionalDataTestDomain,
    additionalDataTypeDomain,
    busyCounter,
    file,
    isEmptyRgaSearchResult,
    resultsNavigation,
    rgaConsignmentDetails,
    rgaDealerDetails,
    rgaDetails,
    rgaQuestionAnswer,
    rgaResultList,
    rgaSelectedMassUpdate,
    searchFilters
});



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/index.js